module.exports = __webpack_public_path__ + "img/eu.62cfd859.png";